<template>
  <div class="skill">
    <div class="body" v-if="model">
      <div class="name">{{ model.data.name }} {{ rating }}</div>
      <div class="range">
        <div class="rating"
             :style="{ width : `${(model.rating() * 100).toFixed(2)}%`}"></div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
    name  : "Skill",
    props : {
        model : {
            type : Object
        }
    },
    computed : {
        rating() {
            if (this.model) {
                const { value, range } = this.model.data;
                return `(${value}/${range})`;
            }
            return "";
        }
    }
};

</script>

<style scoped>

.skill {
    width:180px;
    padding-bottom:10px;
}

.skill > .body > .name {
    font-size:10px;
    text-align:left;
}

.skill > .body > .range {
    border:1px solid #CCCCCC;
    height:2px;
    position:relative;
}

.skill > .body > .range > .rating {
    border:1px solid #000000;
    position:absolute;
    top:-1px;
    left:-1px;
    width:0%;
    height:100%;
    background-image:-webkit-linear-gradient(to right, rgba(var(--core-black-rgb), 0.25), rgba(var(--core-black-rgb), 1));
    background-image:-moz-linear-gradient(to right, rgba(var(--core-black-rgb), 0.25), rgba(var(--core-black-rgb), 1));
    background-image:-ms-linear-gradient(to right, rgba(var(--core-black-rgb), 0.25), rgba(var(--core-black-rgb), 1));
    background-image:linear-gradient(to right, rgba(var(--core-black-rgb), 0.25), rgba(var(--core-black-rgb), 1));
}

</style>
